import React, { useState, useEffect } from "react";
import { Brain, Search, Lightbulb, Sparkles } from "lucide-react";

export const AIThinkingAnimation = () => {
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    { text: "Reading your materials", icon: Search, color: "text-blue-500" },
    { text: "Finding patterns", icon: Lightbulb, color: "text-orange-500" },
    { text: "Organizing ideas", icon: Brain, color: "text-purple-500" },
    { text: "Crafting response", icon: Sparkles, color: "text-emerald-500" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % steps.length);
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  const CurrentIcon = steps[currentStep].icon;

  return (
    <div className="flex items-center gap-3 py-2">
      {/* Icon with subtle pulse */}
      <div className="relative">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-8 h-8 rounded-full bg-theme-1 animate-ping opacity-50"></div>
        </div>

        <div className="relative w-8 h-8 bg-theme-0 rounded-full flex items-center justify-center border border-theme">
          <CurrentIcon
            className={`w-4 h-4 transition-all duration-500 ${steps[currentStep].color}`}
            strokeWidth={2}
          />
        </div>
      </div>

      {/* Pulsing text */}
      <p key={currentStep} className="text-sm text-theme-2 animate-pulse-fade">
        {steps[currentStep].text}
      </p>

      <style>{`
        @keyframes pulse-fade {
          0% {
            opacity: 0.5;
            transform: scale(0.95);
          }
          20% {
            opacity: 1;
            transform: scale(1);
          }
          80% {
            opacity: 1;
            transform: scale(1);
          }
          100% {
            opacity: 0.5;
            transform: scale(0.95);
          }
        }

        .animate-pulse-fade {
          animation: pulse-fade 1.5s ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default AIThinkingAnimation;
